import request from '@/utils/request'
import {
  getToken
} from '@/utils/auth'

export function getSTS(data) {
  const params = {
    header: {
      token: getToken(),
      noNeedUser: true
    },
    content: data
  }

  return request({
    url: '/fjtec-ste-svc/sys/getSTS',
    method: 'post',
    data: params
  })
}
